module.exports = __webpack_public_path__ + "media/images/cplook/apple-touch-icon-76x76-b6c53c7a66354630fe7f76cf6644d2b7.png";